import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'weightKg',
    standalone: false
})
export class WeightKgPipe implements PipeTransform {
    transform(value: number | null | undefined): string {
        if (value == null || Number.isNaN(value)) {
            return '';
        }

        return parseFloat(value.toFixed(2)).toString();
    }
}
